import { TranslateService } from "@ngx-translate/core";

export class ExternalJsonForHtmlModel {
  public jsonString: string;
  private translateService: TranslateService;

  constructor(jsonString: string, translateService: TranslateService) {
    this.jsonString = jsonString;
    this.translateService = translateService;
  }

  public async getHtml() {
    let jsonObject = JSON.parse(this.jsonString);
    return this.jsonPropsToHtml(jsonObject);
  }

  private async jsonPropsToHtml(jsonObject: Object) {
    let result = "";
    for (let [key, value] of Object.entries(jsonObject)) {
      if (typeof (value) == "string" && value != null) {
        result += '</p>';
        result += await this.getKeyHtml(key);
        result += this.replaceLinksAndDoubleTags(value);//.replace(new RegExp('<a href=', 'g'), '<a target="_blank" href=');
      }
      else if (value != null) {
        if (Object.entries(value).length > 0) {
          result += '</p>';
          result += await this.getKeyHtml(key);
          result += await this.jsonSubPropsToHtml(value);
        }
      }
    }
    return result;
  }

  private async jsonSubPropsToHtml(jsonObject: Object) {
    let result = "";
    let tableHeaderAdded = false;
    for (let [key, value] of Object.entries(jsonObject)) {
      if (typeof (value) == "string" && value != null) {
        result += this.replaceLinksAndDoubleTags(value);//.replace(new RegExp('<a href=', 'g'), '<a target="_blank" href=');
        result += `</br>`;
      }
      else if (value != null) {
        if (!tableHeaderAdded) {
          result += '<table>';
          result += await this.addTableHeader(value);
          tableHeaderAdded = true;
        }
        result += this.jsonPropsToHtmlTable(value);
      }
    }
    if (tableHeaderAdded) {
      result += '</table>';
    }
    return result;
  }

  private jsonPropsToHtmlTable(jsonObject: Object): string {
    let result = "";
    result += `<tr>`;
    for (let [key, value] of Object.entries(jsonObject)) {
      result += `<td align="left">`;
      if (typeof (value) == "string" && value != null) {
        result += value.replace(new RegExp('<a href=', 'g'), '<a target="_blank" href=');
      }
      else if (value != null) {
        result += value.toString;
      }
      result += `</td>`;
    }
    result += `</tr>`;
    return result;
  }

  private async addTableHeader(jsonObject: Object) {
    let result = "";
    for (let [key, value] of Object.entries(jsonObject)) {
      result += `<th align="left">`;
      result += await this.translateService.get(`OerLearningOutcomes_${key.charAt(0).toUpperCase() + key.slice(1)}`).toPromise();
      result += `</th>`;
    }
    return result;
  }

  private async getKeyHtml(key: string) {
    if (new RegExp('^[0-9]+$').test(key)) {
      return `<li>`;
    }
    else if (key != "descriptionText") {
      return `<h4>${await this.translateService.get(`OerLearningOutcomes_${key.charAt(0).toUpperCase() + key.slice(1)}`).toPromise()}</h4>`;
    }
    return "";
  }

  private replaceLinksAndDoubleTags(value: string): string {
    return value.replace(new RegExp('<a href=', 'g'), '<a target="_blank" href=').replace(new RegExp('<<', 'g'), '&lt').replace(new RegExp('>>', 'g'), '&gt');
  }
}
